import * as React from 'react';
import '../../../table/table.less';
import { Image } from 'semantic-ui-react';
import { Checkbox, Checkbox2, CheckboxAppearance } from '../../../../../components';
import { CoreHelper, WithCoreProps } from 'ff-shared-components-core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TableColumn } from '../../../table/types';

export interface WithoutHeaderRowProps {
	/**Set a row id to be used on details click */
	rowId: string;
	/**Set the row columns  */
	columns?: TableColumn[];
	/**Set a checkbox(prefix) */
	withCheckbox?: boolean;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**Set an image(prefix) */
	withImage?: boolean;
	/**Set a suffix to the row */
	withSuffix?: boolean;
	/**Set a pathToRedirect on details image click */
	pathToRedirect?: string;
	/**Sets if the checkbox is checked or not */
	isChecked?: boolean;
	/**sets the state of the row selection */
	isSelected?: boolean;
	/**Set an event to be handled when the checkbox is clicked */
	onClick?: (e?: any) => void;
}

export interface WithoutHeaderRowState {
	checked: boolean;
}

type Props = WithoutHeaderRowProps & RouteComponentProps;

class WithoutHeaderRowComponent extends React.PureComponent<Props, WithoutHeaderRowState> {
	render(): React.ReactNode {
		const { withCheckbox, columns, rowImage, withImage, onClick, rowId, isSelected } = this.props;
		return (
			<>
				<li className="ds-table-cell">
					{columns &&
						columns.map(
							(column: TableColumn, index: number): JSX.Element => {
								return (
									<React.Fragment key={CoreHelper.guid() || index}>
										<div
											className={`ds-table-cell-detail ${
												index + 1 === 1 ? 'ds-form-check m-0 table-extra-big-cell' : ''
											} ${
												index + 1 > 1 && index + 1 === columns.length - 1
													? 'flex-column table-normal-currency-cell'
													: ''
											} ${
												index + 1 > 1 && index + 1 <= columns.length
													? 'flex-column table-normal-cell'
													: ''
											} ${index + 1 === columns.length ? 'flex-column table-last-cell' : ''}
											`}
										>
											{withCheckbox && index + 1 === 1 && (
												<Checkbox2
													handleChange={(): void => {
														onClick && onClick(rowId);
													}}
													id={rowId}
													appearance={CheckboxAppearance.whiteOnMobile}
													isChecked={isSelected}
												/>
											)}

											{withImage && index + 1 === 1 && (
												<div className="table-image-cell">
													<Image src={rowImage} alt="" width="32px" height="32px" />
												</div>
											)}

											{withCheckbox && index + 1 === 1 ? (
												<div className="table-first-cell">{column.value}</div>
											) : (
												<>{column.value}</>
											)}
										</div>
									</React.Fragment>
								);
							}
						)}
				</li>
			</>
		);
	}
}

export const WithoutHeaderRow = WithCoreProps<WithoutHeaderRowProps>(withRouter(WithoutHeaderRowComponent));
